export interface FailedPassedEmailPackage{
  Failed:ToCcBccGroup,
  Passed:ToCcBccGroup,
}
export interface ToCcBccGroup{
  Bcc:EmailAuditPackages[],
  Cc:EmailAuditPackages[],
  To:EmailAuditPackages[],
}

export interface EmailAuditPackages {
  FromEmailAddress: string,
  NotificationID: string,
  NotificationSource: string,
  NotificationHistoryID: string,
  Sent: boolean,
  DeliveredSuccessful: boolean,
  DeliveryFailed: boolean,
  SentTimeStamp: Date,
  Status: string,
  Subject: string,
  ToEMailAddress: string,
  EmailMessages:EmailMessages[],
  expanded?:boolean,
  SendEnabled?:boolean,
  selected?:boolean
}

export function updateSend(pckage: EmailAuditPackages){
  let oneSelected = pckage.EmailMessages.filter(msg => msg.IncludeInPackage == true).length>0;
  pckage.SendEnabled = oneSelected && !pckage.Sent;
}

export interface EmailMessages{
  AuditPropertyID: string,
  IncludeInPackage: boolean,
  NotificationID: string,
  NotificationMessageID: string,
  NotificationTemplateID: string,
  PropertyName: string
  selected?:boolean
}
